<template>
  <div class="stones-container">
    <div v-for="(concept, index) in fakeConcepts" class="concept" :style="getConceptStyle(concept, index)" v-if="concept.fake || !concept.confirmed">
      <transition>
        <div class="hightlight" v-if="!concept.confirmed">
          <div class="circle circle-1" :style="getHightlightStyle(concept)" />
          <div class="circle circle-2" :style="getHightlightStyle(concept)" />
          <div class="circle circle-3" :style="getHightlightStyle(concept)" />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
/* global THREE */

export default {
  name: 'HeaderStonesContainer',

  components: {

  },
  data: function () {
    return {

    }
  },
  props: {
    maxConcepts: {
      type: Number,
      default: 10
    },
    concepts: {
      type: Array,
      required: true
    }
  },

  methods: {
    getConceptStyle (concept, index) {
      let opacity = 0.2
      if (index < 4) {
        opacity = 0.5
      }
      return {
        left: ((index * 100) / (this.maxConcepts - 1)) + '%',
        opacity
      }
    },

    getHightlightStyle (concept) {
      let color = concept.categoryObject ? new THREE.Color(concept.categoryObject.color).getHexString() : null
      return {
        borderColor: '#' + color
      }
    }
  },
  computed: {
    fakeConcepts () {
      let ret = []
      for (let i = 0; i < this.maxConcepts; i++) {
        if (this.concepts[i]) {
          ret.push(this.concepts[i])
        } else {
          ret.push({fake: true, confirmed: true})
        }
      }
      return ret
    }
  }
}
</script>

<style scoped lang="scss">
@import 'variables';
@import 'mixins';




.concept {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: $c-black;
}

.hightlight {
  position: absolute;
  left: 3px;
  top: 3px;
  width: 20px;
  height: 20px;
  transform: translate(-50%, -50%);

  .circle {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    border-style: solid;
    border-width: 2px;
  }

  .circle-1 {
    width: 40%;
    height: 40%;
    opacity: 1;
  }
  .circle-2 {
    width: 70%;
    height: 70%;
    opacity: 0.6;
  }
  .circle-3 {
    width: 100%;
    height: 100%;
    opacity: 0.25;
  }
}



</style>



// WEBPACK FOOTER //
// src/molecules/HeaderStonesContainer.vue